(function() { window.GUID_c1653d8c_533f_41f3_b286_89b02b185167 = { getGuid: function() { return "c1653d8c-533f-41f3-b286-89b02b185167"; } }; })();
var RegistrationStatus;
(function (RegistrationStatus) {
    BindElements();
    function BindElements() {
        var result = $('#DivisionGroupResult');
        $('.BtnDivisionGroup').on('click', function (e) {
            e.preventDefault();
            var divgrid = $(this).data('divgrid');
            RefreshDivisionGroup(divgrid);
        });
        function RefreshDivisionGroup(divGrId) {
            var data = {
                divisionGroupId: divGrId
            };
            CompuSport.Ajax.Get(CSParameters.BaseUrl + 'RegistrationStatus/RefreshDivisionGroup/' + CSParameters.SportEventId, data, function (response) {
                result[0].innerHTML = response;
                $.removeCookie('lastRegStatusDivGroupId' + CSParameters.SportEventId, { path: '/' });
                $.cookie('lastRegStatusDivGroupId' + CSParameters.SportEventId, divGrId, { expires: 365, path: '/' });
            });
        }
        if (result.length > 0) {
            var lastRegStatusDivGroupId = $.cookie('lastRegStatusDivGroupId' + CSParameters.SportEventId);
            if (lastRegStatusDivGroupId != null) {
                RefreshDivisionGroup(lastRegStatusDivGroupId);
            }
            else {
                $('#MessageWhenEmpty').show();
            }
        }
    }
    RegistrationStatus.BindElements = BindElements;
})(RegistrationStatus || (RegistrationStatus = {}));

//# sourceMappingURL=RegistrationStatus.js.map
